"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Reader_1 = require("fp-ts/lib/Reader");
var Apply_1 = require("fp-ts/lib/Apply");
var function_1 = require("fp-ts/lib/function");
var product_left_coproduct_left_utils_1 = require("../typeclasses/product-left-coproduct-left/product-left-coproduct-left.utils");
var monad_reader_utils_1 = require("../typeclasses/monad-reader/monad-reader.utils");
var productLeft = function (fa, fb) {
    return Reader_1.asks(function (e) { return function_1.tuple(fa.run(e), fb.run(e)); });
};
var runReader = function (fa, e) { return fa.run(e); };
exports.reader = tslib_1.__assign({}, Reader_1.reader, { asks: Reader_1.asks,
    runReader: runReader,
    productLeft: productLeft });
exports.sequenceTReader = Apply_1.sequenceT(exports.reader);
exports.combineReader = product_left_coproduct_left_utils_1.productMapLeft(exports.reader);
exports.deferReader = monad_reader_utils_1.defer(exports.reader);
//# sourceMappingURL=reader.utils.js.map